import { inject, Injectable } from '@angular/core';
import { CanMatch, Route, Router, UrlSegment } from '@angular/router';
import { NomWebServicesJson } from '@common/services/nom-web-services-json';
import { VisualStateService } from '@common/services/visual-state-service';
import { Store } from '@ngrx/store';
import { AppService } from '@src/suite/app.service';
import { NavigationActions } from '@src/suite/common/store/navigation/actions/navigation.actions';

import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class RouteGuard implements CanMatch {
    private appService = inject(AppService);
    private router = inject(Router);
    private authService = inject(AuthService);
    private store = inject(Store);
    nomWebServicesJson = inject(NomWebServicesJson);
    visualStateService = inject(VisualStateService);

    async canMatch(route: Route, segments: UrlSegment[]): Promise<boolean> {
        const { path } = route;
        if (this.getTokenFromPath(path)) {
            this.visualStateService.isDesktop = true;
            return true;
        }

        if (this.getDesktopMode()) {
            this.visualStateService.isDesktop = true;
        }
        const providerName = localStorage.getItem('providerName') ? localStorage.getItem('providerName') : '';
        const idToken = localStorage.getItem('idToken') ? localStorage.getItem('idToken') : '';
        const sessionDataStatus = await this.appService.loadSessionData();
        if (sessionDataStatus) {
            return true;
        } else if (providerName === 'OKTA' && idToken) {
            await this.authService.loginWithToken(providerName);
        } else if (this.authService.isTokenValid(idToken)) {
            await this.authService.loginWithToken(providerName);
        } else if (localStorage.getItem('accessToken')) {
            await this.authService.loginWithToken(providerName);
        } else {
            // Save the attempted URL so we can redirect back after login
            const attemptedUrl = '/' + segments.map(s => s.path).join('/');
            if (attemptedUrl && attemptedUrl !== '/') {
                this.store.dispatch(NavigationActions.setRedirectAfterLogin({ path: attemptedUrl }));
            }
            this.nomWebServicesJson.clearSessionData();
            this.router.navigate(['/login'], { queryParamsHandling: 'preserve' } /* path.slice(path.indexOf('?')) */ /* path.slice(path.indexOf('?')) */);
            return false;
        }
    }

    private getDesktopMode(): boolean {
        return !!localStorage.getItem('DesktopMode');
    }

    private getTokenFromPath(path: string): string {
        let token = null;
        if (path) {
            const queryParamsIndex: number = path.indexOf('?');
            if (queryParamsIndex > -1) {
                const queryParamsStr: string = path.substring(queryParamsIndex + 1);
                if (queryParamsStr) {
                    const queryParamsArray: string[] = queryParamsStr.split('&');
                    if (queryParamsArray && queryParamsArray.length > 0) {
                        for (const param of queryParamsArray) {
                            if (param) {
                                const index = param.indexOf('=');
                                if (index > -1) {
                                    const key = param.substring(0, index);
                                    const value = param.substring(index + 1);
                                    if (key && key === 'token') {
                                        token = decodeURIComponent(value);
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return token;
    }
}
